import createStore from './createStore'

const store = createStore()

export default store
